"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var final_search = null;
function useSearch(params, setParams) {
    var _a = react_1.useState(''), search = _a[0], setSearch = _a[1];
    var performSearch = function (search) {
        setSearch(search);
        final_search = search;
        if (search === '') {
            delete params.search;
            return setParams(__assign(__assign({}, params), { page: 1 }));
        }
        if (search.length <= 1) {
            return;
        }
        setTimeout(function () {
            if (search === final_search) {
                setParams(__assign(__assign({}, params), { search: search, page: 1 }));
            }
        }, 400);
    };
    return [search, performSearch];
}
exports.default = useSearch;
